import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://caspian-sales.lemueltech.com/sales',
  // baseURL: 'http://localhost:7700/sales',
  // baseURL: 'http://192.168.43.42:7700/sales',
  withCredentials: true
});

// export const BASE_URL = 'http://192.168.43.42:7700/sales';

export const BASE_URL = 'https://caspian-sales.lemueltech.com/sales';
export const ACCOUNT_URL = 'https://caspian-finance-server-58e8b535cab0.herokuapp.com/accounting/';


export default Axios;
